<template>
<v-container>
  <v-card style="border-radius: 8px;">
    <v-container>
    <v-card-title>
      <v-btn flat round color="primary" @click="createNewRule($event)">+ Create new rule</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="cCommentRules"
      :search="search"
    >
      <template v-slot:items="props">
        <td>{{ props.item.postid }}</td>
        <td>{{ props.item.keywords }}</td>
        <td>{{ props.item.responsename }} </td>
        <td class="justify-center">
          <v-icon
            small
            @click="editRule($event,props.item)"
          >
            edit
          </v-icon>
        </td>
        <td class="justify-center">
          <v-icon
            small
            @click="deleteRule(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    </v-container>
  </v-card>
  <v-menu v-model="openmenu"
        :close-on-click = "false"
        :position-x="x"
        :position-y="y"
        offset-x
        :close-on-content-click="false"
        :nudge-width="600">
    <v-card>
    <v-card-title>
      <div>
        <h3 class="subheading">Set Rule</h3>
        <div class="caption grey--text">Create or update your comment rule</div>
      </div>
      <v-spacer></v-spacer> 
          <v-btn icon @click="cancelRule"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-container grid-list-xl>
        <v-layout >
            <v-flex xs5>
                <v-card-title>
                    <h2 class="font-weight-regular">Post</h2>
                </v-card-title>
            </v-flex>             
            <v-flex xs7>
                <v-radio-group v-model="postoption">
                    <v-radio
                        label="Any"
                        value="any"
                    ></v-radio>
                    <v-radio
                        label="Specific"
                        value="specific"
                    ></v-radio>
                </v-radio-group>
            </v-flex>
        </v-layout>
        <v-layout v-if="postoption == 'specific'">
            <v-flex xs5>
                    <v-card-title>
                        <h2 class="font-weight-regular">Post ID</h2>
                    </v-card-title>
            </v-flex> 
            <v-flex xs7>
                <v-text-field
                    label="Post id"
                    placeholder="Get your Post id from facebook" 
                    v-model="postid" 
                    hint="Go to facebook page -> publishing tools -> click on post to check post id" 
                    persistent-hint            
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout >
            <v-flex xs5>
                    <v-card-title>
                        <h2 class="font-weight-regular">Comments</h2>
                    </v-card-title>
            </v-flex>             
            <v-flex xs7>
                <v-radio-group v-model="commentsoption">
                    <v-radio
                        label="Any"
                        value="any"
                    ></v-radio>
                    <v-radio
                        label="Specific Keywords"
                        value="specific"
                    ></v-radio>
                </v-radio-group>
            </v-flex>
        </v-layout>
                <v-layout v-if="commentsoption == 'specific'">
            <v-flex xs5>
                    <v-card-title>
                        <h2 class="font-weight-regular">Keywords</h2>
                    </v-card-title>
            </v-flex> 
            <v-flex xs7>
                <v-text-field
                    label="Keyword"
                    placeholder="Press enter to add another keyword" 
                    v-model="keyword" 
                    persistent-hint
                    hint="Press enter after keyword to add another"
                    v-on:keyup.enter="addKeyword"            
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs5>
            </v-flex> 
            <v-flex xs7>
            <v-card flat class="mt-2 ml-4 blue-grey lighten-5" style="border-radius: 8px;">
                <v-chip v-for="(keyword,keywordsindex) in keywords" 
                        :key="keywordsindex" 
                        small 
                        close 
                        outline
                        @input="keywordDelete(keywordsindex)">
                    {{keyword}}
                </v-chip>
            </v-card>
            </v-flex>                    
        </v-layout>
        <v-layout>
            <v-flex xs5>
                    <v-card-title>
                        <h2 class="font-weight-regular">Response to send</h2>
                    </v-card-title>
            </v-flex>             
            <v-flex xs7>
                <v-select
                    item-text="name"  
                    item-value="id"                   
                    :items="cResponses"
                    label="Select the response to send"
                    v-model="response" 
                    hint="Typing delay, Set value, Userinput and integration in the response will be ignore"
                    persistent-hint
                    return-object                   
                ></v-select>
            </v-flex>
        </v-layout>
      <v-card-actions class="ma-0">
          <v-spacer></v-spacer>                  
              <v-btn round flat color="primary" @click="cancelRule">Cancel</v-btn>
              <v-btn round flat color="primary" @click="saveRule">Save</v-btn>                
      </v-card-actions> 
    </v-container>
    </v-card>
</v-menu> 
  </v-container>
</template>

<script>
import {str,firebase} from '@/plugins/firebase.js';
import store from '../store';
  export default {
    data () {
      return {
        postoption:'any',
        postid:null,
        commentsoption:'any',
        keyword:null,
        keywords:[],
        response:null,
        update:false,
        updateIndex:null,
        ruleid:null,
        x:null,
        y:null,
        search: '',
        headers: [
          { text: 'Post', align: 'left', value: 'post'},
          { text: 'Kewywords', align: 'left', value: 'keywords',sortable: false},
          { text: 'Response', value: 'response', sortable: false },
          { text: '', value: 'editrule', sortable: false},
          { text: '', value: 'deleterule', sortable: false}
        ]
      }
    },
    methods:{
      createNewRule(event){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
            let status = true
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },
      saveRule(){
        console.log(this.responseId)
        let pid,commentkeywords
        if(this.postoption == 'any'){
          pid  = 'any'
        }
        else{
          pid  = this.postid
        }

        if(this.commentsoption == 'any'){
          commentkeywords  = ['any']
        }
        else{
          commentkeywords  = this.keywords
        }

            let rule = {
              postid:pid,
              keywords:commentkeywords,
              responseid:this.response.id,
              responsename:this.response.name
            }
            if (this.update){
              let updateIndex = this.updateIndex
              let ruleid = this.ruleid
              this.$store.dispatch('aupdatecommentRule',{updateIndex,ruleid,rule})
              this.update = false
              this.updateIndex = null
              this.ruleid = null
              let status = false
              this.$store.dispatch('aresponsemenuStatusChange',status)
            }else{
              this.$store.dispatch('asavecommentRule',rule)
              let status = false
              this.$store.dispatch('aresponsemenuStatusChange',status)
            }
            
        },
        cancelRule(){
            let status = false
            this.$store.dispatch('aresponsemenuStatusChange',status)
        },
        editRule(event,item){
            event.preventDefault()
            this.x = event.clientX
            this.y = event.clientY
          console.log(item)
          if(item.postid == 'any'){
            this.postoption = 'any'
          }
          else{
            this.postoption = 'specific'
            this.postid = item.postid
          }
          if(item.keywords.length == 1 &&  item.keywords[0] == 'any'){
            this.commentsoption = 'any'
          }
          else{
            this.commentsoption = 'specific'
            this.keywords = item.keywords
          }
          this.response = {
            id: item.responseid,
            name: item.responsename
          }
          this.ruleid = item.id
          let ruleid = this.ruleid
          this.updateIndex = this.cCommentRules.findIndex(getindex)
          let status = true
          this.update = true
          this.$store.dispatch('aresponsemenuStatusChange',status)
                     
          function getindex(crule){
              if(crule.id == ruleid)
              {
                return true
              }
            }
        },
        deleteRule(item){
          let ruleid = item.id
          let ruleindex = this.cCommentRules.findIndex(getindex)
          console.log(ruleindex)
          this.$store.dispatch('adeletecommentRule',{ruleid,ruleindex})
           function getindex(crule){
              if(crule.id == ruleid)
              {
                return true
              }
            }
        },
        addKeyword(){
            if (this.keyword != null){
            this.keywords.push(this.keyword)
            this.keyword = null
           }
        },
        keywordDelete(keywordsindex){
            this.keywords.splice(keywordsindex,1)
        }

    },
    computed:{
      openmenu(){
            return this.$store.state.responseMenuStatus
        },
        pageid(){
            return this.$route.params.page_id
        },
        cCommentRules(){
            if(this.$store.state.responses.length > 0)
            {
                return this.$store.state.commentRules
            }
            else {
                return []
            }            
        },
        cResponses(){
            if(this.$store.state.responses.length > 0)
            {
                return this.$store.state.responses
            }
            else {
                return []
            }            
        }
    }
  }
</script>